import { ENVIRONMENTAL_STATUS_WIDGET_TYPE } from '../../../widgets/environmentalStatusConfig';

export const EDITABLE_TRAILING_ROWS = 2;
export const WATER_TANK_WIDGET_TYPE = 'water-tank';
export const HIDDEN_WIDGET_EDITOR_PROP_KEYS = new Set([
  'themeMode',
  'freeMovement',
  'linkToNearby',
]);
export const VALUE_COLOR_WIDGET_TYPES = [
  'gauge',
  'liquid',
  WATER_TANK_WIDGET_TYPE,
  'radial-gauge',
  'label',
];
export const SHOW_UNIT_WIDGET_TYPES = [
  'gauge',
  'liquid',
  WATER_TANK_WIDGET_TYPE,
  'radial-gauge',
  'label',
  'number',
];
export const LIQUID_STYLE_PROTECTED_COLOR_KEYS = [
  'cardBackgroundColor',
  'titleColor',
  'valueColor',
  'unitColor',
  'glowColor',
];
export const NUMERIC_VALUE_WIDGET_TYPES = new Set([
  'gauge',
  'radial-gauge',
  'liquid',
  WATER_TANK_WIDGET_TYPE,
  'label',
  'number',
  'slider',
  'led',
  'switch',
  'push-button',
  'pipe',
  'elbow',
  'water-pump',
]);
export const DEFAULT_WIDGET_GRID_GAP = 8;
export const MIN_RESIZABLE_WIDGET_WIDTH = 1;
export const MIN_RESIZABLE_WIDGET_HEIGHT = 1;

export const ENVIRONMENTAL_STATUS_MIN_WIDTH = MIN_RESIZABLE_WIDGET_WIDTH;
export const ENVIRONMENTAL_STATUS_MIN_HEIGHT = MIN_RESIZABLE_WIDGET_HEIGHT;

export const DATASTREAM_COLOR_WIDGET_TYPES = [
  ...VALUE_COLOR_WIDGET_TYPES,
  'number',
  'slider',
];
export const SLIDER_NUMBER_CONTENT_ALIGNMENT_OPTIONS = [
  { label: 'Auto', value: 'auto' },
  { label: 'Top', value: 'top' },
  { label: 'Center', value: 'center' },
  { label: 'Bottom', value: 'bottom' },
  { label: 'Title Line', value: 'title-line' },
];

export const getSpannedWidgetSize = (
  baseSize,
  spanCount,
  gap = DEFAULT_WIDGET_GRID_GAP
) => (baseSize * spanCount) + (Math.max(0, spanCount - 1) * gap);

export const getMinimumWidgetSizeForType = () => ({
  width: MIN_RESIZABLE_WIDGET_WIDTH,
  height: MIN_RESIZABLE_WIDGET_HEIGHT,
});

export const getDefaultWidgetDimensions = (type, defaultWidth, defaultHeight) =>
  type === WATER_TANK_WIDGET_TYPE
    ? { width: defaultWidth, height: defaultWidth }
    : type === ENVIRONMENTAL_STATUS_WIDGET_TYPE
      ? {
          width: getSpannedWidgetSize(defaultWidth, 2),
          height: getSpannedWidgetSize(defaultHeight, 2),
        }
      : { width: defaultWidth, height: defaultHeight };

export const isHiddenWidgetEditorPropKey = (key) =>
  HIDDEN_WIDGET_EDITOR_PROP_KEYS.has(key) || String(key || '').endsWith('Light');
